module.exports = __webpack_public_path__ + "static/media/error_illustration_myway.8e91355a.svg";